import React from 'react';
import { Check } from 'lucide-react';
import { STEPS } from './constants';

export function ProgressIndicator({ step, goToStep }) {
  return (
    <div className="flex items-center justify-center mb-12" data-testid="progress-indicator">
      {[1, 2, 3, 4].map((s) => (
        <div key={s} className="flex items-center">
          <button
            onClick={() => {
              if (s < step) goToStep(s);
            }}
            disabled={s > step}
            className="flex flex-col items-center group min-w-[100px]"
            data-testid={`progress-step-${s}`}
          >
            <div 
              className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-sm transition-all duration-300 shadow-sm ${
                step > s 
                  ? 'bg-[#0F2040] text-white cursor-pointer group-hover:ring-4 group-hover:ring-[#0F2040]/15 group-hover:scale-105' 
                  : step === s
                    ? 'bg-[#4ABFCF] text-white ring-4 ring-[#4ABFCF]/20 scale-105'
                    : 'bg-slate-100 text-slate-400 border-2 border-slate-200'
              }`}
            >
              {step > s ? <Check className="w-5 h-5" /> : s}
            </div>
            <span className={`text-xs mt-2 font-semibold transition-colors ${
              step === s ? 'text-[#4ABFCF]' : step > s ? 'text-[#0F2040]' : 'text-slate-400'
            }`}>
              {STEPS[s - 1].label}
            </span>
            <span className={`text-[10px] mt-0.5 transition-colors leading-tight ${
              step >= s ? 'text-slate-500' : 'text-slate-300'
            }`}>
              {STEPS[s - 1].desc}
            </span>
          </button>
          {s < 4 && (
            <div className={`w-12 lg:w-20 h-0.5 mx-1 rounded-full transition-all duration-500 -mt-6 ${
              step > s ? 'bg-[#0F2040]' : 'bg-slate-200'
            }`} />
          )}
        </div>
      ))}
    </div>
  );
}
